import { inject, Injectable, OnDestroy, Provider } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Injectable()
export class TranslocoMatDatepickerIntl
  extends MatDatepickerIntl
  implements OnDestroy
{
  private readonly transloco = inject(TranslocoService);
  private subscription?: Subscription;

  constructor() {
    super();
    this.subscription = this.transloco.langChanges$.subscribe(() =>
      this.applyTranslations(),
    );
    this.applyTranslations();
  }

  private applyTranslations(): void {
    const translate = (key: string) => this.transloco.translate(key);

    this.calendarLabel = translate('Calendar');
    this.openCalendarLabel = translate('Open calendar');
    this.closeCalendarLabel = translate('Close calendar');
    this.prevMonthLabel = translate('Previous month');
    this.nextMonthLabel = translate('Next month');
    this.prevYearLabel = translate('Previous year');
    this.nextYearLabel = translate('Next year');
    this.prevMultiYearLabel = translate('Previous 24 years');
    this.nextMultiYearLabel = translate('Next 24 years');
    this.switchToMonthViewLabel = translate('Choose date');
    this.switchToMultiYearViewLabel = translate('Choose month and year');
    this.startDateLabel = translate('Start date');
    this.endDateLabel = translate('End date');
    this.comparisonDateLabel = translate('Comparison range');

    this.changes.next();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}

export function provideTranslocoMatDatepickerIntl(): Provider[] {
  return [
    TranslocoMatDatepickerIntl,
    { provide: MatDatepickerIntl, useExisting: TranslocoMatDatepickerIntl },
  ];
}
